// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"2247e5f4","371":"9016573c","717":"4ee820ec"}[chunkId] + ".chunk.js";
};